<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>{{ header }}</h1>
        </template>
        <p>{{ message }}</p>
        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Confirming..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button
                class="ml-2 py-2 px-4 rounded-md bg-primary-lightest"
                @click="close"
            >
                Cancel
            </button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            required: true,
        },
        header: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        submit() {
            this.loading = true;

            this.$emit("resolve", {
                type: this.type,
            });

            this.loading = false;
        },
        close() {
            this.$emit("close");
        },
    },
};
</script>
